import React from "react";
import { useFootballContext } from "../../../state/football-play/context";
import DynamicActions from "./DynamicActions";
import { useGameContextContext } from "../../../state/game-context/context";

const PlayStateTransitions = ({
	onSelectTransition,
	buttonSize,
	textAlign,
	columns,
	spacing,
	currentTransition,
	hideIcons,
	fitHeight
}) => {
	const { state: footballContextState } = useFootballContext();
	const { state } = useGameContextContext();
	const timeConfig = state.showTimeConfig();

	const transitions = footballContextState.allowedTransitions();

	return (
		<DynamicActions
			transitions={transitions}
			onSelect={(transition) => onSelectTransition(transition)}
			buttonSize={buttonSize}
			textAlign={textAlign}
			columns={columns}
			spacing={spacing}
			currentTransition={currentTransition}
			hideIcons={hideIcons}
			fitHeight={fitHeight}
			disableKeyListener={!!timeConfig}
		/>
	);
};

export default PlayStateTransitions;
